import { render, staticRenderFns } from "./ChoiceItemEdit.vue?vue&type=template&id=52bde893&scoped=true"
import script from "./ChoiceItemEdit.vue?vue&type=script&lang=js"
export * from "./ChoiceItemEdit.vue?vue&type=script&lang=js"
import style0 from "./ChoiceItemEdit.vue?vue&type=style&index=0&id=52bde893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bde893",
  null
  
)

export default component.exports